import { render, staticRenderFns } from "./LandingPagePolicyDocumentComponent.vue?vue&type=template&id=0030ecde&scoped=true&"
import script from "./LandingPagePolicyDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPagePolicyDocumentComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPagePolicyDocumentComponent.vue?vue&type=style&index=0&id=0030ecde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030ecde",
  null
  
)

export default component.exports